<template>
  <div class="modal-backdrop">
    <div class="card col-lg-4 col-md-8 col-11 p-0 marginper15 mx-auto">
      <div class="modal-content border-0">
        <div class="modal-header">          
          <button type="button" class="close" id="closebtn" @click="closeNoProfileIdModal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body  pb-5">
            <div class="text-center">
                <div>
                    <span class="proximanova-thin fontsize16 black60">To access these screens (or) functionality you should create your profile first.</span>
                </div>
                <button class="button-cancel-font backgroundcolorblack mouseoverbtn2 borderradius20 pointer white border  proximanova mt-4 p-1 pl-3 pr-3 mx-auto" @click="NavToCreateProfile">Create Profile</button>
            </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import router from '../router.js'
export default{
   data() {
        return{
        }
    },
    methods:{
        closeNoProfileIdModal(){
            this.$emit('closeNoProfileIdModal')
        },
        NavToCreateProfile : function(){
            var btn = document.getElementById('closebtn')
            btn.click()
            router.push({
                name : 'createprofile'
            })
        }
    },
    mounted() {
        
    },

}

</script>

<style scoped>
@import '../css/modal.css';
</style>